var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineTicket2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.31 22.75c-4.17 0-5.44-1.27-5.44-5.44v-.46c0-.41.34-.75.75-.75.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6-.41 0-.75-.34-.75-.75v-.46c0-4.17 1.27-5.44 5.44-5.44h9.38c4.17 0 5.44 1.27 5.44 5.44v.94c0 .41-.34.75-.75.75-.88 0-1.6.72-1.6 1.6 0 .88.72 1.59 1.6 1.59.41 0 .75.34.75.75-.01 4.16-1.28 5.43-5.44 5.43H7.31zm.01-1.5h9.38c3.12 0 3.84-.51 3.93-3.28a3.1 3.1 0 0 1-2.34-3c0-1.45 1-2.67 2.35-3.01v-.28c0-3.35-.59-3.94-3.94-3.94H7.31c-3.28 0-3.91.57-3.94 3.74a3.11 3.11 0 0 1 2.35 3.01c0 1.45-1 2.68-2.34 3.02.02 3.18.65 3.74 3.94 3.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9.5V7c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM9.25 16.17v-3.33c0-.41.34-.75.75-.75s.75.34.75.75v3.33c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM9.25 22v-2.5c0-.41.34-.75.75-.75s.75.34.75.75V22c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24 7.75a.74.74 0 0 1-.69-.46.772.772 0 0 1 .16-.82l2.93-2.93c2.7-2.7 4.35-2.7 7.04 0l.6.6a.75.75 0 0 1 0 1.06c-.4.4-.51.99-.28 1.5.11.23.09.5-.05.72a.75.75 0 0 1-.62.33H7.24zm8.14-1.5c-.02-.53.11-1.06.38-1.52l-.13-.13c-2.09-2.09-2.83-2.09-4.92 0L9.05 6.25h6.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTicket2);
export default __webpack_public_path__ + "static/media/vuesax-outline-ticket-2.ff669dfdb8902dbee345811720ae7253.svg";
export { ForwardRef as ReactComponent };